import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GlobalStateContext } from './GlobalState';
import PlaylistsDropdownPlayer from './PlaylistsDropdownPlayer';

const Player = () => {
  const navigate = useNavigate();
  const { isLoggedInSpotify, globalList } = useContext(GlobalStateContext);

  if (!isLoggedInSpotify) {
    return (
      <div className="container text-center">
        <h1 className="cover-heading">Player</h1>
        <div className="alert alert-info" role="alert">
          <p>This function is not available if you are not logged in to Spotify</p>

          <a
            href="/login-home"

            style={{
              backgroundColor: '#007bff', // Example button styling
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              textDecoration: 'none', // Remove underline from link
              cursor: 'pointer',
            }}
          >
            Login with Spotify
          </a>


        </div>



      </div>
    );
  }

  return (
    <div className="container">
      <h1 className="cover-heading">Player</h1>
      <p className="lead">Open the Spotify Appl , load the playlist and Run.
      </p>
      You can also preview here your playlists.

      <PlaylistsDropdownPlayer />
      <br />

    </div>
  );
};

export default Player;
